import highcharts from 'highcharts';
import more from 'highcharts/highcharts-more';
more(highcharts);
import bellcurve from 'highcharts/modules/histogram-bellcurve';
bellcurve(highcharts);
import boost from 'highcharts/modules/boost';
boost(highcharts);